<template>
  <a-input :value="value" :label="label">
    <slot>
      {{ value }}
    </slot>
  </a-input>
</template>

<script>
export default {
  props: {
    value: [String, Number, Boolean],
    label: String,
  },
};
</script>